<template>
    <div>
        <div class="col text-center propertytype">

            <div class="row mt-5 mapkey justify-content-center">
                <div class="col-md-2"></div>
                <div class="col-2 d-none d-sm-none d-md-block">
                    <button> Key</button>
                </div>
                <div class="col-4 col-md-2 salemapicon">
                    <i></i>
                    <p>Sale</p>
                </div>
                <div class="col-4 col-md-2 leasemapicon">
                    <i></i>
                    <p>Lease</p>
                </div>
                <div class="col-4 col-md-2 projectmapicon">
                    <i></i>
                    <p>Project</p>
                </div>
                <div class="col-md-2"></div>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="property-map col" id="map">
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        props: ['properties'],
        data() {
            return {
                map: null,
                markers: [],
            }
        },
        watch: {
            properties: function (properties) {
                if (this.map === null) {
                    this.map = this.drawMap();
                }
                this.removeMarkers();
                this.addProperties(this.map, properties);
            },
        },
        methods: {
            drawMap: function () {
                const element = document.getElementById('map');
                const options = {
                    zoom: 14,
                    navigationControl: false,
                    mapTypeControl: false,
                    draggable: true,
                    zoomControl: true,
                    scaleControl: false,
                    scrollwheel: false,
                    disableDoubleClickZoom: true,
                    center: new google.maps.LatLng(38.695514, -90.419019),
                    mapTypeId: google.maps.MapTypeId.ROADMAP
                };

                return new google.maps.Map(element, options);
            },
            removeMarkers() {
                this.markers.forEach(function (marker) {
                    marker.setMap(null);
                });
                this.markers = [];
            },
            addProperties: function (map, properties) {
                const bounds = new google.maps.LatLngBounds();

                properties.forEach(property => {
                    const position = new google.maps.LatLng(property.latitude, property.longitude);

                    let icon = '/themes/ldc/assets/images/lease-map.png';
                    if (property.type === 'Sale') {
                        icon = '/themes/ldc/assets/images/sale-map.png';
                    }
                    else if (property.type === 'Project') {
                        icon = '/themes/ldc/assets/images/project-map.png';
                    }

                    const marker = new google.maps.Marker({
                        position,
                        map,
                        title: property.city + ', ' + property.state,
                        icon: icon,
                    });

                    this.markers.push(marker);

                    const infowindow = new google.maps.InfoWindow();
                    const infoWindowText = this.generateInfoWindowText(property);

                    google.maps.event.addListener(marker, 'click', (function (marker, infoWindowText, infowindow) {
                        return function () {
                            infowindow.setContent(infoWindowText);
                            infowindow.open(map, marker);
                        };
                    })(marker, infoWindowText, infowindow));

                    map.fitBounds(bounds.extend(position));
                });

                var listener = google.maps.event.addListener(map, "idle", function () {
                    if (map.getZoom() > 16) map.setZoom(16);
                    google.maps.event.removeListener(listener);
                });

            },
            propertyImage: function(property) {
                if (property.images.length === 0){
                    return 'https://placehold.it/828x408';
                }
                return property.images[0].path;
            },
            generateInfoWindowText: function (property) {
                return `
                    <div class="propertmapinfo">
                        <div class="propertyimage"><img src="${this.propertyImage(property)}" width="100%">
                            <div class="leasetag">${property.type}</div>
                        </div>
                        <div class="propertycopy">
                            <pre>${property.usage}</pre>
                           ${this.shoppingCenterName(property)}
                            <h3>${property.city}, ${property.state}</h3>
                            <p>${property.street}</p>
                        </div>
                        <div class="row p-2 border-top">
        
                            <div class="col">GLA: ${property.square_feet}</div>
                            <div class="col">Price per SQF: ${property.negotiable ? 'Negotiable' : '$' + property.price_per_sqft}</div>
                            <div class="col">NNN Rate: $${property.nnn_rate}</div>
                        </div>
                        <a href= "/property/${property.slug}" ><button type="button" class="btn btn-dark btn-sm btn-block">Property Info</button></a>
                        </div>
                `;
            },
            shoppingCenterName(property){
                if (property.shopping_center_name === null) {
                    return '';
                }

                return '<h3>' + property.shopping_center_name + '</h3>';
            }
        },
    }

</script>


// WEBPACK FOOTER //
// themes/ldc/assets/js/properties/PropertyMap.vue